const staticModules = [
    { id: 1, name: 'Sales' },
    { id: 2, name: 'Operation' },
    { id: 3, name: 'License Management' },
    { id: 4, name: 'Product' },
    { id: 5, name: 'User Manager' },
    { id: 6, name: 'Setting' },
    { id: 7, name: 'Contact' },
    { id: 8, name: 'Account' },
    { id: 9, name: 'Dashboard' },
    { id: 10, name: 'Reports' },
    { id: 11, name: 'HR' }
  ];
  
  export default staticModules;
  